<template>
  <div class="bed-classes-page">
    <div class="header">
      <h2>🛏️ Bed Charge Classes</h2>
      <button class="btn-add" @click="showAddModal = true">
        + Add New Class
      </button>
    </div>

    <table class="classes-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Class Name</th>
          <th>Description</th>
          <th>Charge Per Day (KES)</th>
          <th>Admission Charge (KES)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cls, index) in bedClasses" :key="cls.id">
          <td>{{ index + 1 }}</td>
          <td>{{ cls.name }}</td>
          <td>{{ cls.description }}</td>
          <td>{{ cls.bed_cash_charge }}</td>
          <td>{{ cls.admission_cash_charge }}</td>
          <td>
            <button class="btn-edit" @click="editClass(cls)">Edit</button>
            <button disabled class="btn-delete" @click="deleteClass(cls.id)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Add/Edit Modal -->
    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ editMode ? "Edit Class" : "Add New Class" }}
          </h5>
          <button class="close" @click="closeModal">&times;</button>
        </div>

        <div class="modal-body">
          <label>Class Name:</label>
          <input type="text" v-model="newClass.name" />

          <label>Description:</label>
          <input type="text" v-model="newClass.description" />

          <label>Charge Per Day (KES):</label>
          <input type="number" v-model="newClass.bed_cash_charge" />

          <label>Admission Charge (KES):</label>
          <input type="number" v-model="newClass.admission_cash_charge" />
        </div>

        <div class="modal-footer">
          <button class="btn-save" @click="saveClass">
            {{ editMode ? "Update" : "Save" }}
          </button>
          <button class="btn-cancel" @click="closeModal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import showNotification from "../../../notification/notify";
export default {
  name: "BedClassesSettings",
  data() {
    return {
      bedClasses: [],
      showAddModal: false,
      editMode: false,
      newClass: {
        id: null,
        name: "",
        bed_cash_charge: "",
        admission_cash_charge: "",
        description: "",
      },
    };
  },
  methods: {
    async callApiData() {
      const url = "inpatient/getCompanyBedChargeClasses";
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);
      //   console.log(rs);

      this.bedClasses = rs.data;
    },
    closeModal() {
      this.showAddModal = false;
      this.newClass = { id: null, name: "", price: "", admission_charge: "" };
      this.editMode = false;
    },
    async saveClass() {
      console.log("getting here");

      if (
        !this.newClass.name ||
        !this.newClass.bed_cash_charge ||
        !this.newClass.admission_cash_charge
      ) {
        alert("All fields are required.");
        return;
      }
      //   if (!this.editMode) {
      const url = "inpatient/createBedChargeClass";
      const body = {
        name: this.newClass.name,
        description: this.newClass.description,
        bed_charge: this.newClass.bed_cash_charge, // Replace with the actual ID of the sale rate
        admission_charge: this.newClass.admission_cash_charge,
      };
      try {
        await generalApiRequest(url, "POST", body, 1);
        this.closeModal();
        showNotification("Class saved successfully!", "success");
        this.callApiData();
      } catch (error) {
        this.closeModal();
        showNotification("Error saving!", "error");
      }
      //   }
    },
    editClass(cls) {
      this.newClass = { ...cls };
      this.editMode = true;
      this.showAddModal = true;
    },
    deleteClass(id) {
      if (confirm("Delete this class?")) {
        this.bedClasses = this.bedClasses.filter((c) => c.id !== id);
      }
    },
  },
  filters: {
    currency(value) {
      return `KES ${parseFloat(value).toLocaleString()}`;
    },
  },

  mounted() {
    this.callApiData();
  },
};
</script>

<style scoped>
.bed-classes-page {
  padding: 1.5rem;
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header h2 {
  font-size: 1.5rem;
}

.btn-add {
  background: #2786f7;
  color: #fff;
  padding: 0.45rem 1rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.classes-table {
  width: 100%;
  border-collapse: collapse;
}

.classes-table th,
.classes-table td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
}

.classes-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.btn-edit,
.btn-delete {
  padding: 0.35rem 0.7rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-edit {
  background: #2786f7;
  color: #fff;
  margin-right: 0.4rem;
}

.btn-delete {
  background: #e31919;
  color: #fff;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 10, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 0.4rem;
  width: 90%;
  max-width: 35vw;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  color: #fff;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  border-radius: 50%;
  width: 28px;
  height: 28px;
}

.modal-body {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.modal-body label {
  font-weight: 600;
}

.modal-body input[type="text"],
.modal-body input[type="number"] {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}

.btn-save {
  background: #2786f7;
  color: #fff;
  border: none;
  padding: 0.5rem 1.1rem;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-cancel {
  background: #777;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
